module.exports = __webpack_public_path__ + "img/image (12).1a579b6b.webp";